import * as React from "react";
import { AColumn } from "src/components/tables/AsyncTable";
import { viewDateTimeUtc } from "src/common/formats";
import { ZBom3 } from "../ZBom3";

export const createBom3SummaryColumns = (store: {
  readonly showSizeLine: boolean;
  readonly showTotalAmount: boolean;
  makeTotalValue(srcTotalValue: number | null | undefined): string;
}): AColumn<ZBom3>[] => [
  {
    key: "state",
    title: "State",
    render: (_, { state }) => state?.name,
  },
  {
    key: "name",
    title: "Name",
    render: (_, { name }) => <b>{name}</b>,
  },
  ...(store.showSizeLine
    ? [
        {
          key: "sizeLine",
          title: "Size line",
          render: (_, { sizeLineName }) => sizeLineName,
        } satisfies AColumn<ZBom3>,
      ]
    : []),
  ...(store.showTotalAmount
    ? [
        {
          key: "totalAmount",
          title: "BOM Total",
          align: "right",
          render: (_, { totalAmount }) => store.makeTotalValue(totalAmount),
        } satisfies AColumn<ZBom3>,
      ]
    : []),
  {
    key: "createdDate",
    title: "Дата создания",
    render: (_, { createdDate }) => viewDateTimeUtc(createdDate),
  },
  {
    key: "updatedDate",
    title: "Дата последнего изменения",
    render: (_, { updatedDate }) => viewDateTimeUtc(updatedDate),
  },
  {
    key: "createdBy",
    title: "Автор экземпляра",
    render: (_, { createdBy }) => createdBy,
  },
  {
    key: "updatedBy",
    title: "Автор последнего изменения",
    render: (_, { updatedBy }) => updatedBy,
  },
];
